/* eslint @typescript-eslint/strict-boolean-expressions: off */

import { gql } from "@apollo/client";

import { queryItemGqlFragment, toQueryType, QueryType } from "./queryItem";

import { ListBrowseQueriesQuery } from "src/gql/codegen/graphql";

/* Get variables for the query */

export interface ApiParams {
  filter: {
    freetext: string;
    isCodeSearch?: boolean;
    owner?: {
      type: "user" | "team";
      handle: string;
    };
    tag?: string;
  };
  order:
    | {
        by: "favorites";
        time_range: "24h" | "7d" | "30d" | "all";
      }
    | {
        by: "created_at";
      }
    | {
        by: "name";
      };
  page: number;
  pageSize: number;
}

/* The actual query */
// Not assigned to constant here. Using generated. See _GrahphQL requests_ in readme.
gql`
  query ListBrowseQueries(
    $filter_name: String_comparison_exp!
    $filter_tags: jsonb_comparison_exp
    $filter_custom: [queries_bool_exp!]
    $order: [queries_order_by!]
    $limit: Int!
    $offset: Int!
    $include_favs_last_24h: Boolean! = false
    $include_favs_last_7d: Boolean! = false
    $include_favs_last_30d: Boolean! = false
    $include_favs_all_time: Boolean! = false
  ) {
    queries(
      where: {
        is_temp: { _eq: false }
        name: $filter_name
        tags: $filter_tags
        _and: $filter_custom
      }
      limit: $limit
      offset: $offset
      order_by: $order
    ) {
      ...QueryItem
    }
    queries_aggregate(
      where: {
        is_temp: { _eq: false }
        name: $filter_name
        tags: $filter_tags
        _and: $filter_custom
      }
    ) {
      aggregate {
        count
      }
    }
  }

  ${queryItemGqlFragment}
`;

/* Selector: Transform query result data to more usable data structure */
export function transformData(data: ListBrowseQueriesQuery): {
  queries: QueryType[];
  total_count: number;
} {
  return {
    queries: data.queries.map(toQueryType),
    total_count: data.queries_aggregate?.aggregate?.count ?? 0,
  };
}
